export const caseConverters = {
  methods: {
    toCamelCase(str) {
      return str.replace(/\W+(.)/g, (match, chr) => chr.toUpperCase())
    },
    toSentenceCase(str) {
      const sentence = str.replace('_', ' ').toLowerCase()
      return `${sentence[0].toUpperCase()}${sentence.slice(1)}`
    },
    toTitleCase(str) {
      const sentence = str.replace('_', ' ').toLowerCase()
      return sentence.replace( /\w\S*/g, w => `${w[0].toUpperCase()}${w.slice(1)}`)
    },
  },
}

export default {
  caseConverters,
}
